import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface PermissionSetResponse {
  success: boolean;
  data: {
    permissions: Record<string, any>;
  };
  message?: string;
}

export const fetchPermissionSet = async (): Promise<PermissionSetResponse> => {
  const response = await customAxios.get<PermissionSetResponse>(
    `/permissions/set`
  );
  return response.data;
};

export const useGetPermissionSet = () =>
  useQuery<PermissionSetResponse, AxiosError>(
    ["permission-set"],
    () => fetchPermissionSet(),
    {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnMount: false,
    }
  );
